import Vue from "vue";
import Vuex from "vuex";
import state from "./state";
import mutations from "./mutations";
import getters from "./getters";
import headerMenu from "./modules/headerMenu";
import back from "./modules/back";
import user from "./modules/user";
import userCenter from "./modules/userCenter";
import articleDetail from "./modules/articleDetail";

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  modules: {
    headerMenu,
    back,
    user,
    userCenter,
    articleDetail
  },
});

export default store;
